import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconLayers';
/** Renders an SVG icon. */
const SvgLayers = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.586 4.09a1 1 0 0 1 .828 0l11 5a1 1 0 0 1 0 1.82l-11 5a1 1 0 0 1-.828 0l-11-5a1 1 0 0 1 0-1.82zM7.416 10 16 13.902 24.583 10 16 6.098zm1.244 4.336a1 1 0 0 1-.496 1.324l-.747.34L16 19.901 24.583 16l-.747-.34a1 1 0 0 1 .828-1.82l2.75 1.25a1 1 0 0 1 0 1.82l-11 5a1 1 0 0 1-.828 0l-11-5a1 1 0 0 1 0-1.82l2.75-1.25a1 1 0 0 1 1.324.496m0 6a1 1 0 0 1-.496 1.324l-.747.34L16 25.901 24.583 22l-.747-.34a1 1 0 0 1 .828-1.82l2.75 1.25a1 1 0 0 1 0 1.82l-11 5a1 1 0 0 1-.828 0l-11-5a1 1 0 0 1 0-1.82l2.75-1.25a1 1 0 0 1 1.324.496"
      />
    </svg>
  );
};
SvgLayers.displayName = displayName;
export default SvgLayers;
